<template>

    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm" label-position="left" :show-message="false">
    <div class="bootstrap modal-content">
      <div class="modal-header">
        <h5 class="modal-title">서명요청 계약서 {{mode==='update'?'정보수정':'만들기'}}</h5>
        <button type="button" class="close" @click="$emit('dismiss')">X</button>
      </div>
      <div class="modal-body">

        <el-form-item label="광고주 선택" prop="companySeq">
            <el-row :gutter="10" >
            <search-company v-model="ruleForm.companySeq" :show-label="false" :keyword-span="7" :company-span="16" @selected="companySelected"></search-company>
            </el-row>
        </el-form-item>

        <hr v-if="mode == 'insert'" />

        <el-form-item label="문서 제목" prop="title" v-if="mode == 'insert'">
            <el-input v-model="ruleForm.title"></el-input>
        </el-form-item>

        <hr v-if="mode == 'insert'"/>

        <el-form-item label="문서양식 선택" prop="docKind" v-if="mode == 'insert'">
            <el-radio-group v-model="ruleForm.docKind" >
                <el-radio label="U" @change="ruleForm.templateId=''">양식을 PC에서 업로드 (자유서식)</el-radio>
                <el-radio label="T" >MODUSIGN에 등록한 템플릿 양식 사용</el-radio>
            </el-radio-group>
        </el-form-item>


        <el-form-item label="템플릿 선택" prop="templateId" :required="ruleForm.docKind === 'T'" v-if="mode == 'insert'">
            <template #label>
                <span :class="{'text-gray':ruleForm.docKind !== 'T'}" >템플릿 선택</span>
            </template>
            <div class="form-group">
            <el-select v-model="ruleForm.templateId" filterable placeholder="템플릿 선택" :disabled="ruleForm.docKind !== 'T'">
                <el-option v-for="item in templateList" :key="item.id" :label="item.title" :value="item.id"></el-option>
            </el-select>
            </div>
        </el-form-item>

        <hr/>

        <el-form-item label="RMS 담당자" prop="rmsDamdangSeq">
            <el-select v-model="ruleForm.rmsDamdangSeq" placeholder="RMS담당자 선택" >
                <el-option
                  v-for="item in $store.state.rmsDamdang.items"
                  :value="item.id"
                  :label="item.damdangName">
                </el-option>
            </el-select>
        </el-form-item>

      </div>
      <div class="modal-footer">
        <el-form-item>
                <el-button type="primary" @click="submitForm('ruleForm')">{{mode==='update'?'정보수정':'계약서 작성'}}</el-button>
                <el-button @click="$emit('dismiss')">닫 기</el-button>
            </el-form-item>

<!-- 
        <button type="button" class="btn btn-secondary" @click="hideAll" data-bs-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary" @click="other">Save changes</button> -->


      </div>
    </div>
    </el-form>

</template>

<script>
import SearchCompany from '@/components/Pages/Views/Common/SearchCompany.vue'
import ModusignProxy from '@/proxies/ModusignProxy';
import ModusignWaitModal from './ModusignWaitModal.vue';


export default {
    name: 'ContractModal',
    created() {
        this.getTemplateList()
        if(this.mode == 'update') {
            this.ruleForm = Object.assign({}, this.ruleForm, this.metaData )
            this.ruleForm = {...this.ruleForm, companySeq:Number(this.ruleForm.companySeq), rmsDamdangSeq:Number(this.ruleForm.rmsDamdangSeq)}
        }
        
    },
    components: {
        SearchCompany
    },
    props: {
        mode: {
            type: String
        },
        handler: {
            type: Function
        },
        metaData: {
            type: Object
        }
    },
    data() {
      return {
        templateList: [],
        ruleForm: {
          companySeq: '',
          companyName: '',
          title: '',
          docKind: 'U',
          templateId: '',
          rmsDamdang: '',
          rmsDamdangSeq: '',
        },
        rules: {
          companySeq: [
            { required: true, message: ' ', trigger: 'change' },
          ],
          title: [
            { required: true, message: ' ', trigger: 'blur' },
          ],
          docKind: [
            { required: true, trigger: 'change' }
          ],
          templateId: [
            { trigger: 'change' }
          ],
          rmsDamdangSeq:[
            { required: true, message: ' ', trigger: 'change' },
          ],
        }
      };
    },    
    watch: {
        'ruleForm.rmsDamdangSeq': {
            handler: function () {
                const damdang = this.$store.state.rmsDamdang.items.find( item => item.id == this.ruleForm.rmsDamdangSeq )
                this.ruleForm.rmsDamdang = (damdang || {}).damdangName
            },
            deep: true
        }
    },
    methods: {
        hideAll() {
            this.$modal.hideAll()
        },
        companySelected( {companyName}) {
            this.ruleForm.companyName = companyName
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
            if (valid) {

                //console.log(this.ruleForm)

                //this.$emit('close', 'abc');

                if(this.mode === 'insert') {

                    this.$modal.show(
                        ModusignWaitModal,
                        { },
                        { width:'600px', height: 'auto', scrollable: false },
                        { }
                    )

                }


                this.handler( this.ruleForm, this )
                // this.$emit('submit');


                if(this.mode === 'update') {
                    this.$emit('close')
                }

            } else {
                alert('필수 항목들을 빠짐없이 입력해 주세요')
                return false;
            }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        async getTemplateList() {

            const api = async (offset, limit) => {
                const response = await new ModusignProxy({ offset, limit }).getTemplateList();
                return response;
            }

            let response = await api(0, 100)
            this.templateList = response.data.templates

            const total = response.data.count
            for(let i = 100; i<total; i+=100) {
                let response = await api(i, 100)
                this.templateList = this.templateList.concat(response.data.templates)
            }

            // api(0,100).then(response=>this.templateList = response.data.templates)
            
        }
    },

}
</script>